"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { useTenantTimeZone } from "@/hooks/shared/useStudioClock";
import {
  getPrivateLessonEntriesFromApi,
  type PrivateLessonsFilters,
} from "@/lib/services/privateLessonsService";
import { QueryKeys } from "@/lib/types";

export function usePrivateLessonsCalendar(
  filters: PrivateLessonsFilters,
  options?: { enabled?: boolean },
) {
  const accessToken = useAccessToken();
  const timeZone = useTenantTimeZone();
  const enabled = options?.enabled !== false && !!accessToken;

  return useQuery({
    queryKey: [QueryKeys.PrivateLessonsCalendar, filters, timeZone ?? null],
    queryFn: () =>
      getPrivateLessonEntriesFromApi(accessToken!, filters, timeZone),
    enabled,
    staleTime: 2 * 60 * 1000,
  });
}
